/**
 * @license Copyright (c) Microsoft Corporation. All rights reserved.
 */
var CaptchaElements = /** @class */ (function () {
    function CaptchaElements() {
    }
    CaptchaElements.hipId = "ms_captcha_holder";
    CaptchaElements.hipScriptId = "ms_captcha_scriptholder";
    CaptchaElements.solutionId = "ms_captcha_solution";
    CaptchaElements.typeId = "ms_captcha_type";
    CaptchaElements.captchaFlowId = "ms_captcha_flow_id";
    return CaptchaElements;
}());
export { CaptchaElements };
